import { render } from "./TeamButton.vue?vue&type=template&id=1034dcaa"
import script from "./TeamButton.vue?vue&type=script&lang=js"
export * from "./TeamButton.vue?vue&type=script&lang=js"

import "./TeamButton.vue?vue&type=style&index=0&id=1034dcaa&lang=less"

import exportComponent from "/Users/cain/Workspaces/projects/roar/roar-fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.30_vue@3.5.30_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__